import { NavLink, useLocation } from "react-router-dom";
import { StreakBadge } from "./StreakBadge";
import { ThemeToggle } from "./ThemeToggle";
import { Wordmark } from "./Wordmark";
import { SearchIcon } from "./icons";

interface TopBarProps {
  streak: number;
  onSearch: () => void;
}

const NAV: ReadonlyArray<{ to: string; label: string; matches?: (path: string) => boolean }> = [
  {
    to: "/",
    label: "Index",
    matches: (p) => p === "/" || p.startsWith("/day/") || p.startsWith("/word/"),
  },
  { to: "/review", label: "Review" },
  { to: "/progress", label: "Progress" },
  { to: "/design-system", label: "System" },
  { to: "/settings", label: "Settings" },
];

export function TopBar({ streak, onSearch }: TopBarProps) {
  const { pathname } = useLocation();

  return (
    <header className="topbar">
      <div className="container row-s" style={{ height: 64 }}>
        <NavLink to="/" style={{ textDecoration: "none" }}>
          <Wordmark />
        </NavLink>
        <nav className="row-c" style={{ gap: 4 }}>
          {NAV.map((n) => {
            const active = n.matches ? n.matches(pathname) : pathname.startsWith(n.to);
            return (
              <NavLink
                key={n.to}
                to={n.to}
                className={`topnav-link ${active ? "is-active" : ""}`}
              >
                {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="row-c" style={{ gap: 10 }}>
          <button className="search-trigger" onClick={onSearch} title="Search · ⌘K" type="button">
            <SearchIcon />
            <span className="search-trigger__label">Search words…</span>
            <span className="search-trigger__kbd t-mono">⌘K</span>
          </button>
          <StreakBadge value={streak} />
          <ThemeToggle />
        </div>
      </div>
      <hr className="rule" />
    </header>
  );
}
